const autoNgTemplateLoaderTemplate1 = require('./registriesRepositoryTagsDatatable.html');

angular.module('portainer.registrymanagement').component('registriesRepositoryTagsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'RegistryRepositoriesTagsDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    removeAction: '<',
    retagAction: '<',
    advancedFeaturesAvailable: '<',
    paginationAction: '<',
    loading: '<',
  },
});
